// Components==============
import LabelWrapper from 'components/UI/Label/LabelWrapper';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import './Body.module.scss';
// =========================

export default function Body({ theme }: { theme?: ThemeEntity }) {
  const translate = useTranslate();

  const categories = useRedux((state) =>
    state.category?.entities.allIds.map(
      (id) => state.category?.entities.byId[id]
    )
  );

  return (
    <div styleName="wrapper">
      <p>{theme?.description}</p>
      <LabelWrapper
        title={translate('general.terms.categories')}
        labels={theme?.categories?.map(
          (cat) => categories?.find((c) => c?.id === cat)?.name || ''
        )}
      />
    </div>
  );
}
